<app-selector
  label="Slider Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="sliderGameCoreService.sliderGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="sliderGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
